import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";

export default function NoAccess({
    title = "Access Restricted",
    message = "You do not have permission to view this page. Contact your administrator for additional access.",
    animationUrl = "https://lottie.host/62f10dcb-c2fc-4ba4-9e34-d3bb7ed2a69d/1DLMO2eCHm.json",
    showGoHome = true,
    maxWidth = 240,
}) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        pt: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        alignContent: "center",
        px: 2
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 5,
          maxWidth: 520,
          width: "100%",
          textAlign: "center",
          borderRadius: 4,
        }}
      >
        <Box sx={{ maxWidth, margin: "0 auto", mb: 2 }}>
          <Lottie animationData={null} path={animationUrl} autoplay loop style={{ maxWidth: "100%" }} />
        </Box>

        <Typography variant="h4" fontWeight={700} gutterBottom>
          {title}
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {message}
        </Typography>

        {showGoHome && (
          <Button
            variant="outlined"
            fullWidth
          onClick={() => navigate("/")}
        >
          {('Navigate to Dashboard')}
        </Button>
        )}
      </Paper>
    </Box>
  );
}
